import React from 'react';

function Story() {
  return (
    <section className="section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="img">
              <img src="/light/assets/imgs/works/projects/2/4.jpg" alt="" />
            </div>
            <div className="cont section-padding">
              <div className="row">
                <div className="col-md-3 sm-mb30">
                  <h6>The Story</h6>
                </div>
                <div className="col-lg-6 col-md-9">
                  <div className="text">
                    <p>
                      We provide digital experience services to startups and
                      small businesses. We help our clients succeed by creating
                      brand identities, digital experiences, and print
                      materials. Install any demo, plugin or template in a
                      matter of seconds. Just select the demo and click OK. It’s
                      that easy! The latest design trends meet hand-crafted
                      templates in Ave Collection. Use pre-built sections to
                      speed up your design process. Open a beautiful store,
                      increase your conversion rates and boost your sales in
                      minutes with object-oriented UX.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="img">
              <img src="/light/assets/imgs/works/projects/2/5.jpg" alt="" />
            </div>
            <div className="cont section-padding">
              <div className="row">
                <div className="col-md-3 offset-lg-2 sm-mb30">
                  <h6>Approach</h6>
                </div>
                <div className="col-lg-6 col-md-9">
                  <div className="text">
                    <p>
                      We provide digital experience services to startups and
                      small businesses. We help our clients succeed by creating
                      brand identities, digital experiences, and print
                      materials. Install any demo, plugin or template in a
                      matter of seconds. Just select the demo and click OK. It’s
                      that easy! The latest design trends meet hand-crafted
                      templates in Ave Collection. Use pre-built sections to
                      speed up your design process. Open a beautiful store,
                      increase your conversion rates and boost your sales in
                      minutes with object-oriented UX.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="img">
              <img src="/light/assets/imgs/works/projects/2/6.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Story;
